import React, { useState } from "react";
import { BASE_URL_MEDIA } from "../../api/Constants";
import AttachmentViewer from "../Attachments/AttachmentViewer";

const WorkoutDetails = ({ workout, setShowModal }) => {
  const [showImage, setShowImage] = useState(false);

  return showImage ? (
    <AttachmentViewer
      url={`${BASE_URL_MEDIA}/storage/assets/uploads/${workout?.images[0]?.image}`}
      setShowAttachViewer={setShowImage}
    />
  ) : (
    <div className=" assign-program excercise-modal assign-program trainings-modal mt-4 pt-4">
      <i className="fa fa-times" onClick={() => setShowModal(false)}></i>
      <p className="title-small">Workout Details</p>

      <div className="child-modal">
        <div className="message-body workout-details-modal">
          {workout?.images?.length > 0 && (
            <img
              onClick={() => setShowImage(true)}
              className="workout-image pointer mb-3"
              src={`${BASE_URL_MEDIA}/storage/assets/uploads/${workout?.images[0]?.image}`}
              alt=""
            />
          )}

          <div className="icon-wrapper">
            <i class="fa-regular fa-calendar-days"></i>{" "}
            <span>{workout?.date?.slice(0, 10)}</span>
          </div>
          <div className="icon-wrapper">
            <i class="fa-solid fa-user-tie"></i>{" "}
            <span>{workout?.trainer_name}</span>
          </div>
          <div className="icon-wrapper">
            <i class="fa-solid fa-location-dot"></i>{" "}
            <span>{workout?.location}</span>
          </div>
          <p className="notes-title">Details:</p>
          {workout?.details && <p className="notes">{workout?.details}</p>}
          <p className="notes-title">Notes:</p>
          {workout?.notes && <p className="notes">{workout?.notes}</p>}
        </div>
      </div>
    </div>
  );
};

export default WorkoutDetails;
